export interface PatientAvailabilityPortalModel {
  patientID: number;
  canRequestChange: boolean;
  dateRanges: PatientAvailabilityDateRangeModel[];
  daysOfWeek: PatientAvailabilityDayOfWeekModel[];
  availabilities: PatientAvailabilityBindingModel[];
  requests: PatientAvailabilityChangeRequestModel[];
  pendingRequest?: PatientAvailabilityChangeRequestModel;
}

export interface PatientAvailabilityDateRangeModel {
  id: number;
  programID: number;
  programName: string;
  description: string;
  startDate: Date;
  endDate: Date;
  timeRanges: PatientAvailabilityTimeRangeModel[];
}

export interface PatientAvailabilityTimeRangeModel {
  id: number;
  availabilityDateRangeID: number;
  description: string;
  startTime: Date;
  endTime: Date;
}

export interface PatientAvailabilityDayOfWeekModel {
  id: number;
  name: string;
}

export interface PatientAvailabilityBindingModel {
  availabilityID: number;
  availabilityDateRangeID: number;
  effectiveStartDate?: Date;
  effectiveEndDate?: Date;
  hoursPerWeek?: number;
  comments?: string;
  slots: PatientAvailabilitySlotModel[];
}

export interface PatientAvailabilitySlotModel {
  availabilityTimeRangeID: number;
  dayOfWeekID: number;
}

export interface PatientAvailabilityChangeRequestModel {
  id: number;
  patientID: number;
  inquiryID?: number;
  availabilityDateRangeID: number;
  availabilityID?: number;
  effectiveStartDate: Date;
  hoursPerWeek?: number;
  comments?: string;
  statusID: number;
  status: string;
  createdDate: Date;
  approvedDate?: Date;
  declinedDate?: Date;
  decisionNotes?: string;
  slots: PatientAvailabilitySlotModel[];
}

export interface PatientAvailabilityChangeRequestSubmissionModel {
  availabilityDateRangeID: number;
  effectiveStartDate: Date | string;
  hoursPerWeek?: number;
  comments?: string;
  slots: PatientAvailabilitySlotModel[];
}
